var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidthPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.219 20.0022C18.9905 20.237 18.9905 20.6087 19.219 20.8239C19.4476 21.0587 19.8095 21.0587 20.019 20.8239L23.8286 16.9109C23.9429 16.7935 24 16.637 24 16.5C24 16.363 23.9429 16.2065 23.8286 16.0891L20.019 12.1761C19.7905 11.9413 19.4286 11.9413 19.219 12.1761C18.9905 12.4109 18.9905 12.7826 19.219 12.9978L22.0571 15.913L1.94286 15.913L4.78095 12.9978C4.89524 12.8804 4.95238 12.7239 4.95238 12.587C4.95238 12.45 4.89524 12.2935 4.78095 12.1761C4.55238 11.9413 4.19048 11.9413 3.98095 12.1761L0.171429 16.0891C-0.0571429 16.3239 -0.0571429 16.6957 0.171429 16.9109L3.98095 20.8239C4.20952 21.0587 4.57143 21.0587 4.78095 20.8239C5.00952 20.5891 5.00952 20.2174 4.78095 20.0022L1.94286 17.087H22.0381L19.219 20.0022Z",
    fill: "#85909F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4545 5.45455H12.5455V2.54545C12.5455 2.23636 12.3091 2 12 2C11.6909 2 11.4545 2.23636 11.4545 2.54545V5.45455H8.54545C8.23636 5.45455 8 5.69091 8 6C8 6.30909 8.23636 6.54545 8.54545 6.54545H11.4545V9.45455C11.4545 9.76364 11.6909 10 12 10C12.3091 10 12.5455 9.76364 12.5455 9.45455V6.54545H15.4545C15.7636 6.54545 16 6.30909 16 6C16 5.69091 15.7636 5.45455 15.4545 5.45455Z",
    fill: "#85909F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidthPlus);
export default __webpack_public_path__ + "static/media/widthPlus.9f0e88538c8aba5d1a3b7c729f270d3e.svg";
export { ForwardRef as ReactComponent };